import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ConsoleSidebar from "./ConsoleSidebar";
import ViewOnlyBanner from "../ViewOnlyBanner";
import { MODAL_CSS } from "./ConsoleUI";
import {
  isBranchScopedAdmin,
  getUserBranchName,
  getSelectedBranchId,
} from "../../services/PermissionService";

/**
 * Layout shell for the redesigned operations console: fixed sidebar, cream
 * topbar carrying the page title, then the page's own content.
 *
 * Pages supply their title through the `title` / `subtitle` props on
 * ConsolePage (below) rather than each rebuilding the bar, so the chrome stays
 * identical across all 25 screens.
 */
class ConsoleLayout extends Component {
  render() {
    return (
      <div className="console">
        {/* The dialog stylesheet, mounted once for the whole console. Pages used
            to inject their own copy; 19 of them did, several from inside a
            .map() so it rendered per row, and four ended up with duplicates. */}
        <style dangerouslySetInnerHTML={{ __html: MODAL_CSS }} />
        <ConsoleSidebar />
        <div className="console-main">{this.props.children}</div>
      </div>
    );
  }
}

/**
 * One screen inside the console. Renders the topbar and body padding so an
 * individual page only has to describe its own content.
 *
 * The topbar's subtitle defaults to naming the branch in effect — the design
 * shows "Today at Golf Central", and that context is what every figure on the
 * page is filtered by.
 */
class ConsolePageBase extends Component {
  defaultSubtitle() {
    if (isBranchScopedAdmin()) {
      const n = getUserBranchName();
      return n ? `Branch: ${n}` : null;
    }
    return getSelectedBranchId() ? null : "All branches";
  }

  render() {
    const { title, subtitle, actions, children } = this.props;
    const sub = subtitle !== undefined ? subtitle : this.defaultSubtitle();
    return (
      <React.Fragment>
        <div className="console-top">
          <div>
            <div className="console-top__title">{title}</div>
            {sub && <div className="console-top__sub">{sub}</div>}
          </div>
          {actions && <div className="console-top__right">{actions}</div>}
        </div>
        <div className="console-body">
          <ViewOnlyBanner />
          {children}
        </div>
      </React.Fragment>
    );
  }
}

export const ConsolePage = withRouter(ConsolePageBase);
export default withRouter(ConsoleLayout);
